import styled, { css } from "styled-components";
import {UserMenuSectionBox} from "../../user-menu/user-menu/boxes/user-menu-section.box";
import { styledByDevice } from "../../../themes/architecture/styled-by-device";

const commonBalanceSectionMixin = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 1.5rem 1.5rem 1.5rem;
    font-family: ${({theme}) => theme.font.family.ultra};
`;

/**
 * The div was : <div className={`balance-box ${isMobile ? '' : 'user-menu-box'}`}>
 * So for PC I inherit from UserMenuBox and for mobile there's a normal styled div
 */
const UserBalanceSectionDefaultBox = styled(UserMenuSectionBox)`
    ${commonBalanceSectionMixin}
`;

const UserBalanceSectionMobileBox = styled.div`
    ${commonBalanceSectionMixin}
    padding: 0;
`;

export const UserBalanceSectionBox = styledByDevice(UserBalanceSectionDefaultBox, UserBalanceSectionMobileBox);
